module.exports = __webpack_public_path__ + "static/media/VA.1aee6f8b.svg";